import { IResponse } from "models";

export enum ActionType {
  FULL_STRESS_INFO = "action/FULL_STRESS_INFO",
  FULL_STRESS_INFO_SUCCESS = "action/FULL_STRESS_INFO_SUCCESS",
  FULL_STRESS_INFO_ERROR = "action/FULL_STRESS_INFO_ERROR",
  FULL_STRESS_INFO_RESET_DATA = "action/FULL_STRESS_INFO_RESET_DATA",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface FullStressTypeInfoData {
  page: number;
  per_page: number;
  not_implement: boolean;
  start_date?: string;
  end_date?: string;
  interview_request_sent: boolean;
  need_attention: boolean;
  high_stress_1: boolean;
  high_stress_2: boolean;
  interview_request_not_sent: boolean;
}

export interface IFullStressTypeInfoResponse extends IResponse {
  total_record: number;
  current_page: number;
  next_page: number;
  result?: {
    full_stress_result: IFullStressTypeInfo[];
    stress_check_users: IFullStressCheckUser[];
  };
}

export interface IFullStressTypeInfo {
  stress_check_id: number;
  user_id: string;
  patient_id: string;
  name: string;
  date_of_implementation: string;
  stress_situation: number;
  status: number;
  interview_transmission_status: number;
  B: string;
  A_C: string;
  affiliation: string;
  gender: string;
  stress_check_done: boolean;
}

export interface IFullStressCheckUser {
  patient_id: string;
  full_name: string;
  interview_transmission_status: string;
  stress_situation: string;
}
